import styled from 'styled-components';

export const SliderWrapper = styled.div`
  width: 100%;

  .slick-list {
    overflow: hidden;
  }

  .slick-track {
    display: flex !important;
    align-items: center !important;
  }

  .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    height: auto !important;
    float: none !important;
  }

  .slick-slide > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

export const Section = styled.section`
  width: 100%;
  padding: 80px 0;
  background: ${({ bg }) => bg || '#F4F6F9'};
`;

export const SliderContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  display: flex;
`;
